import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[650px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Luxury%20grand%20casino%20entrance%20with%20golden%20decorations%20and%20chandeliers%2C%20dark%20elegant%20atmosphere%2C%20red%20carpet%2C%20warm%20golden%20lighting%2C%20premium%20interior%20design%2C%20dramatic%20architectural%20details%2C%20no%20people%2C%20sophisticated%20editorial%20photography%20style&width=1920&height=1080&seq=hero-casino-main&orientation=landscape"
        alt="新葡京娱乐城 - 顶级在线娱乐平台"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          新葡京娱乐城
        </h1>
        <p className="text-lg md:text-xl text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          顶级在线娱乐平台 · 真人百家乐 · 老虎机 · 体育竞猜<br />
          安全可靠，存取便捷，24小时客服在线
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#"
            className="px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors text-base whitespace-nowrap cursor-pointer"
          >
            立即注册
          </a>
          <Link
            to="/category"
            className="px-8 py-3.5 border border-white/40 text-white font-medium rounded-md hover:bg-white/10 transition-colors text-base whitespace-nowrap"
          >
            浏览游戏
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-3xl mx-auto">
          {[
            { value: '500万+', label: '注册会员' },
            { value: '500+', label: '精选游戏' },
            { value: '99.9%', label: '资金安全率' },
            { value: '24H', label: '客服在线' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-400">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}